import { z } from 'zod'

import {
  createWebComponentPropertyDescriptor,
  standardWebComponentProperties,
  webComponentAttributeParsers,
} from '@salsita-ai/platform-project-sdk/domain'
import { useWebComponentPropertyValue } from '@salsita-ai/platform-project-sdk/react'

export const webComponentProperties = {
  session: createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
  'add-to-cart-url': createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
  'cart-url': createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
} as const

export const useWebComponentProperties = () => {
  return {
    session: useWebComponentPropertyValue(webComponentProperties.session),
    addToCartUrl: useWebComponentPropertyValue(webComponentProperties['add-to-cart-url']),
    cartUrl: useWebComponentPropertyValue(webComponentProperties['cart-url']),
    locale: useWebComponentPropertyValue(standardWebComponentProperties.locale),
  }
}

export const useWebComponentLanguage = () => {
  const { locale } = useWebComponentProperties()
  return locale?.split('-')[0] ?? 'en'
}
